import React from "react"
// import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { createStackNavigator } from "@react-navigation/stack"
import {
  // HomeScreen,
  // HomeTitle,
  // HomeNotification,
  // HomeRefresh,

  ChemicalMultiMeasurementCreateScreen,
  CycleCloseScreen,
  CycleCloseMultipleScreen,
  CycleDetailTitle, CycleDetailRefresh, CycleDetailMore, CycleDetailGraph,
  CycleGraphScreen,
  CycleHistoryScreen, CycleHistoryTitle,
  CycleDiseaseCreateScreen,
  DiseaseDetailScreen,
  DiseaseScreen,
  FarmCreateScreen,
  FarmPondListScreen, FarmPondListSearch,
  FeedCreateScreen,
  FeedingTrayCreateMultipleScreen,
  HarvestCreateScreen,
  HomeRefresh,
  MicrobiologyMultiMeasurementCreateScreen,
  MonitoringScreen,
  PlanktonMultiMeasurementCreateScreen,
  PondCreateMultipleScreen,
  PondPreCreateMultipleScreen,
  PondProfileScreen,
  SamplingCreateScreen,
  ShrimpPriceListScreen,
  ShrimpPriceDetailScreen, ShrimpPriceDetailShare,
  CreateShrimpPriceFirstScreen, CreateShrimpPriceSecondScreen, ShrimpNewsScreen, ShrimpNewsDetailScreen,
  TreatmentCreateScreen,
  WaterQualityMultiMeasurementCreateScreen,
  MortalityCreateScreen,
  FarmPondHeader,
  HeaderSearch,
  // CycleDetailScreen,
  FarmShrimpPriceCreateScreen,
  CycleCreateMultipleScreen,
  FinanceScreen,
  SimulationListScreen,
  SimulationCreateScreen,
  CustomFrTableScreen,
  ParameterListScreen,
  SimulationHeader,
  JalaWebViewScreen,
  ActivityScreen,
  ActivityHeader,
  ActivitySettingScreen, HelpScreen,
  FarmPrivateSellingPriceCreateScreen,
  GotoJalaProScreen
} from "../../screens"
import { color } from "../../theme"
import { View } from "native-base"
import { translate } from "../../i18n"
import { HeaderWithShare } from "../../components"
// import { AutoFeederPondNavigator } from "./auto-feeder-pond/auto-feeder-pond-navigator"
import { CycleNavigator } from "./cycle/cycle-navigator"
import { OverviewNavigator } from "./overview/overview-navigator"
import { OverviewTotalWeightPredictionListRefresh } from "../../screens/home/overview"
import { SimulationNavigator } from "./simulation/simulation-navigator"
import { NotificationNavigator } from "./notification/notification-navigator"
import { MeasurementPredictionNavigator } from "../prediction/measurement-prediction-navigator"

export type HomeNavigatorParamList = {
  // 'Home.Home': undefined,
  'Home.Farm.Create': undefined,
  'Home.Farm.Edit': undefined,
  'Home.Farm.Pond.Create': undefined,
  'Home.Farm.Pond.Create.Detail': undefined,
  'Home.Farm.Pond.List': undefined,
  'Home.Farm.Pond.Setting': undefined,
  'Home.Farm.Pond.Cycle.Create': undefined,
  'Home.Farm.Pond.Cycle.Edit': undefined,
  'Home.FarmShrimpPrice.Create': undefined,
  'Home.JalaWebView': undefined,
  'Home.Pond.PreCreateMultiple': undefined
  'Home.Pond.CreateMultiple': undefined,
  'Home.Cycle.CreateMultiple': undefined,
  'Home.Cycle.CustomFRTable': undefined,
  'Home.Cycle.EditMultiple': undefined,
  'Home.Cycle.Close': undefined,
  'Home.Cycle.CloseMultiple': undefined,
  'Home.Cycle.Stack': undefined,
  'Home.Cycle.Graph': undefined,
  'Home.Cycle.History': undefined,
  'Home.Overview.Stack': undefined,
  'Home.WaterQualityMultiMeasurement.Create': undefined,
  'Home.WaterQualityMultiMeasurement.Edit': undefined,
  'Home.Feed.Create': undefined,
  'Home.Feed.Edit': undefined,
  'Home.FeedingTrayControl.CreateMultiple': undefined,
  'Home.FeedingTrayControl.EditMultiple': undefined,
  'Home.Sampling.Create': undefined,
  'Home.Sampling.Edit': undefined,
  'Home.Treatment.Create': undefined,
  'Home.Treatment.Edit': undefined,
  'Home.Harvest.Create': undefined,
  'Home.Harvest.Edit': undefined,
  'Home.Mortality.Create': undefined,
  'Home.Mortality.Edit': undefined,
  'Home.ChemicalMultiMeasurement.Create': undefined,
  'Home.ChemicalMultiMeasurement.Edit': undefined,
  'Home.PlanktonMultiMeasurement.Create': undefined,
  'Home.PlanktonMultiMeasurement.Edit': undefined,
  'Home.MicrobiologyMultiMeasurement.Create': undefined,
  'Home.MicrobiologyMultiMeasurement.Edit': undefined,
  'Home.CycleDisease.Create': undefined,
  'Home.CycleDisease.Edit': undefined,
  "Home.Monitoring": undefined,
  "Home.Finance": undefined,
  "Home.News": undefined,
  "Home.News.Detail": undefined,
  "Home.Disease": undefined,
  "Home.Disease.Detail": undefined,
  "Home.ShrimpPrice.List": undefined,
  "Home.ShrimpPrice.Detail": undefined,
  "Home.Price.List": undefined,
  "Home.Price.Create.First": undefined,
  "Home.Price.Create.Second": undefined
  // 'Home.AutoFeederPond.Stack': undefined,
  'Home.Overview': undefined,
  'Home.Notifications': undefined,
  'Home.Simulation.List': undefined,
  'Home.Simulation.Stack': undefined,
  'Home.Simulation.Create': undefined,
  'Home.Parameter.List': undefined,
  'Home.Activity.List': undefined,
  'Home.Activity.Setting': undefined,
  'Home.PrivateFarmShrimpPrice.Create': undefined,

  'Home.Help': undefined

  'Home.MeasurementPrediction.Stack': undefined
  
  'Home.GotoJalaPro': undefined
}

// const Stack = createNativeStackNavigator<HomeNavigatorParamList>()
const Stack = createStackNavigator<HomeNavigatorParamList>()

export const HomeStack = {
  index: 0,
  routes: [
    { name: 'Home.Stack', state: { index: 0, routes: [{ name: 'Home.Home' }] } }
  ]
};

export const HomeStackFarmAutoFeederPondList = {
  index: 0,
  routes: [
    { name: 'Home.Stack', state: { index: 0, routes: [{ name: 'Home.AutoFeederPond.Stack' }] } }
  ]
};

export const HomeNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        cardStyle: { flex: 1 },
        headerShown: false,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerTitleContainerStyle: { marginLeft: 0 }
      }}
      // initialRouteName="Home.Home"
    >
      {/* <Stack.Screen */}
      {/*  name="Home.Home" */}
      {/*  component={HomeScreen} */}
      {/*  options={{ */}
      {/*    title: 'Home', */}
      {/*    headerTitle(props) { */}
      {/*      return <HomeTitle/> */}
      {/*    }, */}
      {/*    headerShown: true, */}
      {/*    headerShadowVisible: false, */}
      {/*    headerStyle: { backgroundColor: color.primary }, */}
      {/*    headerTintColor: color.palette.white, */}
      {/*    headerRight(props) { */}
      {/*      return <View flexDirection="row"> */}
      {/*        <HomeRefresh/> */}
      {/*        <HomeNotification/> */}
      {/*      </View> */}
      {/*    } */}
      {/*  }} */}
      {/* /> */}
      <Stack.Screen
        name="Home.Farm.Create"
        component={FarmCreateScreen}
        options={{
          title: translate('farmCreateScreen.title'),
          headerTitle: translate('farmCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Farm.Edit"
        component={FarmCreateScreen}
        options={{
          title: translate('farmEditScreen.title'),
          headerTitle: translate('farmEditScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.Farm.Pond.List"
        component={FarmPondListScreen}
        initialParams={{ data: { text: "" } } as any}
        options={{
          title: 'Farm / Pond List',
          headerTitle: translate('farmPondListScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          header({ navigation, route }) {
            return <FarmPondHeader navigation={navigation} route={route} />
          },
        }}
      />
      <Stack.Screen
        name="Home.Farm.Pond.Setting"
        component={PondProfileScreen}
        options={{
          title: 'Setting Pond',
          headerTitle: translate('pondProfileForm.setting'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.FarmShrimpPrice.Create"
        component={FarmShrimpPriceCreateScreen}
        options={{
          title: translate("farmShrimpPriceCreateScreen.title"),
          headerTitle: translate("farmShrimpPriceCreateScreen.title"),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.JalaWebView"
        component={JalaWebViewScreen}
        options={{
          title: '',
          headerTitle: '',
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.Overview.Stack"
        options={{
          title: 'Overview',
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          headerRight(props) {
            return <View flexDirection="row">
              <OverviewTotalWeightPredictionListRefresh/>
            </View>
          }
        }}
      >{OverviewNavigator}</Stack.Screen>
      <Stack.Screen
        name="Home.Pond.PreCreateMultiple"
        component={PondPreCreateMultipleScreen}
        options={{
          title: translate('pondCreateMultipleScreen.title'),
          headerTitle: translate('pondCreateMultipleScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Pond.CreateMultiple"
        component={PondCreateMultipleScreen}
        options={{
          title: translate('pondCreateMultipleScreen.title'),
          headerTitle: translate('pondCreateMultipleScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Cycle.CreateMultiple"
        component={CycleCreateMultipleScreen}
        options={{
          title: translate('cycleCreateMultipleScreen.title'),
          headerTitle: translate('cycleCreateMultipleScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Cycle.CustomFRTable"
        component={CustomFrTableScreen}
        options={{
          title: translate('customFRScreen.title'),
          headerTitle: translate('customFRScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Cycle.EditMultiple"
        component={CycleCreateMultipleScreen}
        options={{
          title: translate('cycleEditScreen.title'),
          headerTitle: translate("cycleEditScreen.title"),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Cycle.Close"
        component={CycleCloseScreen}
        options={{
          title: 'Cycle Close',
          headerTitle: translate('cycleCloseScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Cycle.CloseMultiple"
        component={CycleCloseMultipleScreen}
        options={{
          title: 'Cycle Close Multiple',
          headerTitle: translate('cycleCloseMultipleScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Cycle.Stack"
        // component={CycleDetailScreen}
        options={{
          title: 'Cycle Detail',
          headerTitle({ tintColor }) {
            return <CycleDetailTitle tintColor={tintColor}/>
          },
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          headerRight(props) {
            return <View flexDirection="row">
              <CycleDetailRefresh/>
              <CycleDetailGraph/>
              <CycleDetailMore/>
            </View>
          }
        }}
      >{CycleNavigator}</Stack.Screen>
      <Stack.Screen
        name="Home.Cycle.Graph"
        component={CycleGraphScreen}
        options={{
          title: 'Cycle Graph',
          headerTitle({ tintColor }) {
            return <CycleDetailTitle tintColor={tintColor}/>
          },
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.Cycle.History"
        component={CycleHistoryScreen}
        options={{
          title: 'Cycle History',
          headerTitle({ tintColor }) {
            return <CycleHistoryTitle tintColor={tintColor}/>
          },
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.WaterQualityMultiMeasurement.Create"
        component={WaterQualityMultiMeasurementCreateScreen}
        options={{
          title: 'Measurement Create',
          headerTitle: translate('measurementCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.WaterQualityMultiMeasurement.Edit"
        component={WaterQualityMultiMeasurementCreateScreen}
        options={{
          title: 'Measurement Edit',
          headerTitle: translate('measurementEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Feed.Create"
        component={FeedCreateScreen}
        options={{
          title: 'Feed Create',
          headerTitle: translate('feedCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Feed.Edit"
        component={FeedCreateScreen}
        options={{
          title: 'Feed Edit',
          headerTitle: translate('feedEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.FeedingTrayControl.CreateMultiple"
        component={FeedingTrayCreateMultipleScreen}
        options={{
          title: 'FeedingTrayControl Create',
          headerTitle: translate('feedingTrayControlCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.FeedingTrayControl.EditMultiple"
        component={FeedingTrayCreateMultipleScreen}
        options={{
          title: 'FeedingTrayControl Edit',
          headerTitle: translate('feedingTrayControlEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Sampling.Create"
        component={SamplingCreateScreen}
        options={{
          title: 'Sampling Create',
          headerTitle: translate('samplingInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Sampling.Edit"
        component={SamplingCreateScreen}
        options={{
          title: 'Sampling Edit',
          headerTitle: translate('samplingInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Treatment.Create"
        component={TreatmentCreateScreen}
        options={{
          title: 'Treatment Create',
          headerTitle: translate('treatmentInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Treatment.Edit"
        component={TreatmentCreateScreen}
        options={{
          title: 'Treatment Edit',
          headerTitle: translate('treatmentInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Harvest.Create"
        component={HarvestCreateScreen}
        options={{
          title: 'Harvest Create',
          headerTitle: translate('harvestInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Harvest.Edit"
        component={HarvestCreateScreen}
        options={{
          title: 'Harvest Edit',
          headerTitle: translate('harvestInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Mortality.Create"
        component={MortalityCreateScreen}
        options={{
          title: translate('mortalityCreateScreen.title'),
          headerTitle: translate('mortalityCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Mortality.Edit"
        component={MortalityCreateScreen}
        options={{
          title: translate('mortalityEditScreen.title'),
          headerTitle: translate('mortalityEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.ChemicalMultiMeasurement.Create"
        component={ChemicalMultiMeasurementCreateScreen}
        options={{
          title: translate('chemicalMultiMeasurementCreateScreen.title'),
          headerTitle: translate('chemicalMultiMeasurementCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.ChemicalMultiMeasurement.Edit"
        component={ChemicalMultiMeasurementCreateScreen}
        options={{
          title: translate('chemicalMultiMeasurementEditScreen.title'),
          headerTitle: translate('chemicalMultiMeasurementEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.PlanktonMultiMeasurement.Create"
        component={PlanktonMultiMeasurementCreateScreen}
        options={{
          title: translate('planktonMultiMeasurementCreateScreen.title'),
          headerTitle: translate('planktonMultiMeasurementCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.PlanktonMultiMeasurement.Edit"
        component={PlanktonMultiMeasurementCreateScreen}
        options={{
          title: translate('planktonMultiMeasurementEditScreen.title'),
          headerTitle: translate('planktonMultiMeasurementEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.MicrobiologyMultiMeasurement.Create"
        component={MicrobiologyMultiMeasurementCreateScreen}
        options={{
          title: translate('microbiologyMultiMeasurementCreateScreen.title'),
          headerTitle: translate('microbiologyMultiMeasurementCreateScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.MicrobiologyMultiMeasurement.Edit"
        component={MicrobiologyMultiMeasurementCreateScreen}
        options={{
          title: translate('microbiologyMultiMeasurementEditScreen.title'),
          headerTitle: translate('microbiologyMultiMeasurementEditScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.CycleDisease.Create"
        component={CycleDiseaseCreateScreen}
        options={{
          title: 'Cycle Disease Create',
          headerTitle: translate('cycleDiseaseInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.CycleDisease.Edit"
        component={CycleDiseaseCreateScreen}
        options={{
          title: 'Cycle Disease Edit',
          headerTitle: translate('cycleDiseaseInput.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Monitoring"
        component={MonitoringScreen}
        initialParams={{ hidden: true, text: "" } as any}
        options={({ navigation, route }) => ({
          // title: 'Monitoring',
          // headerTitle: translate('homeScreen.monitoring'),
          title: (route.params as any).hidden ? 'Monitoring' : null,
          headerTitle: (route.params as any).hidden ? translate('homeScreen.monitoring') : null,
          headerShown: true,
          headerShadowVisible: true,
          headerBackVisible: !!(route.params as any).hidden,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          headerLeftContainerStyle: { display: (route.params as any).hidden ? 'flex' : 'none' },
          headerRight(props) {
            const { hidden } = route.params as any;
            return <View flexDirection="row" mx="16px">
              {hidden ? (
                  <>
                    <HomeRefresh navigation={navigation} route={route} />
                    <FarmPondListSearch navigation={navigation} route={route}/>
                  </>
                ) : <HeaderSearch navigation={navigation} route={route} />
              }
            </View>
          },
        })}
      />
      <Stack.Screen
        name="Home.Finance"
        component={FinanceScreen}
        options={{
          title: 'Finance',
          headerTitle: translate('financeScreen.title'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      {/* <Stack.Screen */}
      {/*   name="Home.AutoFeederPond.Stack" */}
      {/*   options={{ */}
      {/*     title: 'Auto Feeder Pond', */}
      {/*     headerShown: false, */}
      {/*     headerShadowVisible: false, */}
      {/*     headerStyle: { backgroundColor: color.primary }, */}
      {/*     headerTintColor: color.palette.white */}
      {/*   }} */}
      {/* >{AutoFeederPondNavigator}</Stack.Screen> */}
      <Stack.Screen
        name="Home.News"
        component={ShrimpNewsScreen}
        options={{
          title: 'Shrimp News',
          headerTitle: translate('newsScreen.shrimpNews'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.News.Detail"
        component={ShrimpNewsDetailScreen}
        initialParams={{ sharedData: { title: "", message: "", post: null }} as any}
        options={({ navigation, route }) => ({
          title: 'Shrimp News',
          headerTitle: translate('newsScreen.shrimpNews'),
          headerShown: true,
          headerShadowVisible: true,
          header(props){
            const { sharedData } = route.params as any;
            return <HeaderWithShare instagramStory sharedData={sharedData} title={translate('newsScreen.shrimpNews')} navigation={navigation} route={route} />
          },
          // headerStyle: { backgroundColor: color.primary },
          // headerTintColor: color.palette.white
        })}
      />
      <Stack.Screen
        name="Home.Disease"
        component={DiseaseScreen}
        options={{
          title: 'Disease',
          headerTitle: translate('diseaseScreen.shrimpDisease'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Disease.Detail"
        component={DiseaseDetailScreen}
        initialParams={{ sharedData: { title: "", message: "" }} as any}
        options={({ navigation, route }) => ({
          title: 'Disease Detail',
          headerTitle: translate('diseaseScreen.shrimpDisease'),
          header(props){
            const { sharedData } = route.params as any;
            return <HeaderWithShare sharedData={sharedData} title={translate('diseaseScreen.shrimpDisease')} navigation={navigation} route={route} />
          },
          headerShown: true,
          // headerShadowVisible: true,
          // headerStyle: { backgroundColor: color.primary },
          // headerTintColor: color.palette.white
        })}
      />
      <Stack.Screen
        name="Home.ShrimpPrice.List"
        component={ShrimpPriceListScreen}
        options={{
          title: translate('shrimpPriceListScreen.title'),
          headerTitle: translate('shrimpPriceListScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.ShrimpPrice.Detail"
        component={ShrimpPriceDetailScreen}
        options={{
          title: translate('shrimpPriceListScreen.title'),
          headerTitle: translate('shrimpPriceListScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          headerRight(props) {
            return <View flexDirection="row">
              <ShrimpPriceDetailShare />
            </View>
          }
        }}
      />
      <Stack.Screen
        name="Home.Price.Create.First"
        component={CreateShrimpPriceFirstScreen}
        options={{
          title: 'Create Shrimp Price',
          headerTitle: translate('shrimpPriceScreen.createPrice'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          // headerRight(props) {
          //   return <View flexDirection="row">
          //     <FarmPondListSearch/>
          //     <FarmPondListSetting/>
          //   </View>
          // }
        }}
      />
      <Stack.Screen
        name="Home.Price.Create.Second"
        component={CreateShrimpPriceSecondScreen}
        options={{
          title: 'Create Shrimp Price',
          headerTitle: translate('shrimpPriceScreen.createPrice'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          // headerRight(props) {
          //   return <View flexDirection="row">
          //     <FarmPondListSearch/>
          //     <FarmPondListSetting/>
          //   </View>
          // }
        }}
      />
      <Stack.Screen
        name="Home.Notifications"
        options={{
          title: 'Notification',
          headerTitle: translate('homeScreen.notifications'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      >{NotificationNavigator}</Stack.Screen>
      <Stack.Screen
        name="Home.Simulation.List"
        component={SimulationListScreen}
        options={({ navigation, route }) => ({
          title: translate('simulationScreen.title'),
          headerTitle: translate('simulationScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          header(props) {
            return <SimulationHeader navigation={navigation} route={route} />
          },
        })}
      />
       <Stack.Screen
        name="Home.Simulation.Stack"
        options={{
          title: translate('simulationScreen.SimulationTabTitle'),
          headerTitle: translate('simulationScreen.SimulationTabTitle'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          // headerRight(props) {
          //   return <View flexDirection="row">
          //     <OverviewTotalWeightPredictionListRefresh/>
          //   </View>
          // }
        }}
      >{SimulationNavigator}</Stack.Screen>
      <Stack.Screen
        name="Home.Simulation.Create"
        component={SimulationCreateScreen}
        options={{
          title: translate('simulationScreen.inputTitle'),
          headerTitle: translate('simulationScreen.inputTitle'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
       <Stack.Screen
        name="Home.Parameter.List"
        component={ParameterListScreen}
        options={{
          title: translate('parameterListScreen.title'),
          headerTitle: translate('parameterListScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Home.Activity.List"
        component={ActivityScreen}
        options={({ navigation, route }) => ({
          title: translate('cycleToDoScreen.title'),
          headerTitle: translate('cycleToDoScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          header(props) {
            return <ActivityHeader navigation={navigation} route={route} />
          },
        })}
      />
      <Stack.Screen
        name="Home.Activity.Setting"
        component={ActivitySettingScreen}
        options={{
          title: translate('cycleToDoScreen.setting'),
          headerTitle: translate('cycleToDoScreen.setting'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.PrivateFarmShrimpPrice.Create"
        component={FarmPrivateSellingPriceCreateScreen}
        options={{
          title: translate('farmShrimpPriceForm.privateFormTitle'),
          headerTitle: translate('farmShrimpPriceForm.privateFormTitle'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.Help"
        component={HelpScreen}
        options={{
          title: translate('bottomMenu.help'),
          headerTitle: translate('bottomMenu.help'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Home.GotoJalaPro"
        component={GotoJalaProScreen}
        options={{
          headerShown: false,
          headerShadowVisible: false,
        }}
      />
      <Stack.Screen name="Home.MeasurementPrediction.Stack">{MeasurementPredictionNavigator}</Stack.Screen>
    </Stack.Navigator>
  )
}
